import React from 'react';
import './SearchResults.css';

const SearchResults = ({ searchTerm, resultCounts, totalCounts }) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return null;
  }

  const { companyCount, productCount, alternativeCount } = resultCounts;
  const { companies: totalCompanies, products: totalProducts, alternatives: totalAlternatives } = totalCounts;

  return (
    <div className="search-results">
      <div className="search-results-header">
        <h3>លទ្ធផលស្វែងរកសម្រាប់ "{searchTerm}"</h3>
        <div className="search-stats">
          <span className="stat-item">
            <strong>{companyCount}</strong> ក្នុងចំណោម {totalCompanies} ក្រុមហ៊ុន
          </span>
          <span className="stat-item">
            <strong>{productCount}</strong> ក្នុងចំណោម {totalProducts} ផលិតផល
          </span>
          <span className="stat-item">
            <strong>{alternativeCount}</strong> ក្នុងចំណោម {totalAlternatives} ជម្រើសផ្សេងទៅវិញ
          </span>
        </div>
      </div>
      
      {companyCount === 0 && (
        <div className="no-results">
          <div className="no-results-icon">🔍</div>
          <p>រកមិនឃើញលទ្ធផលណាដែលត្រូវនឹង "{searchTerm}" ទេ</p>
          <p className="no-results-suggestion">
            សូមព្យាយាមស្វែងរកជាមួយពាក្យផ្សេងទៅវិញ ឬពិនិត្យការប្រកបរបស់អ្នក
          </p>
        </div>
      )}
    </div>
  );
};

export default SearchResults;
